import register from '@kpsys/angularjs-register';
import UtilsDataService from './utils.data-service';
import UtilController from './util.controller';
import utilRoutes from './util.routes';
import LoggerDataService from './logger.data-service';
import ServerStateDataService from './server-state.data-service';

export default register('uc-utils')
    .config(utilRoutes)
    .controller(UtilController.controllerName, UtilController)
    .service(UtilsDataService.serviceName, UtilsDataService)
    .service(LoggerDataService.serviceName, LoggerDataService)
    .service(ServerStateDataService.serviceName, ServerStateDataService)
    .name();
